<h2 mat-dialog-title>Versandmethode</h2>
<div mat-dialog-content>
	<shop-shippingkind-selector (shippingKindChange)="onChange()"></shop-shippingkind-selector>
</div>
